import {type FormConfig, FormLoaderError} from '@bff/loader-utils';
import {loadAssetWithCache} from './assetCache';

/**
 * Loads form configuration JSON.
 * Deduplicates concurrent requests when React components mount simultaneously
 * (e.g., React Strict Mode double-rendering, concurrent mounts, fast remounts)
 */
export async function loadConfig(configUrl: string): Promise<FormConfig> {
    return loadAssetWithCache(configUrl, async () => {
        let response;
        try {
            response = await fetch(configUrl, {
                headers: {Accept: 'application/json'}
            });
        } catch (error) {
            console.error('An unexpected error occurred while loading the form config: ', error);
            throw new FormLoaderError('An unexpected error occurred while loading the form config', 500);
        }

        if (!response.ok) {
            throw new FormLoaderError('Failed to load form config', 404);
        }

        return (await response.json()) as FormConfig;
    });
}
